package com.shadowings.gero.util

import androidx.compose.runtime.snapshots.Snapshot

actual fun requestUiRepaint() {
    Snapshot.sendApplyNotifications()
}
